import { ArchitecturalPlanPage } from './models/architectural-plan-page.model';

/**
 * Extracts the file ID from a page's folder path for multi-file projects.
 *
 * Modern structure: `projects/{projectId}/files/{fileId}/pages/{pageNum}/`
 * Legacy structure: `projects/{projectId}/pages/{pageNum}/` (returns null)
 *
 * Prefer this over `ArchitecturalPlanPage.getFileId()` because `file_id` is
 * not always populated in plan-metadata.json; the folder path is authoritative.
 */
export function extractFileIdFromPage(page: ArchitecturalPlanPage): string | null {
  const pageFolderPath = page.getPageFolderPath() || '';
  const match = pageFolderPath.match(/\/files\/([^/]+)\/pages\/\d+\/?$/);
  return match ? match[1] : null;
}
